import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';

import EventsTemplatesDrawerMenu from '../../containers/event/dashboards/EventTemplateDrawerMenu';
import Result from '../../containers/event/Result';
import EventsItem from '../../containers/event/Item';
import EventsGroupByFieldOption from '../../containers/event/GroupByFieldOption';
import EventsSplitByFieldOption from '../../containers/event/SplitByFieldOption';
import AggregationContainer from '../../containers/event/AggregationContainer';
import EventsAggregationFieldOption from '../../containers/event/AggregationFieldOption';
import EventItemFilter from '../../containers/event/EventItemFilter';
import EventPeriod from '../../containers/event/EventPeriods';
import NavigationBar from '../navigation/NavigationBar';
import SpinnerWithButton from '../common/SpinnerWithButton';

const StyledEventsViewContainer = styled.div`
  height: calc(100% - 63px);

  .wrapper-sidelist-container {
    display: flex;
    align-items: stretch;
    height: 100%;

    .sidelist-container {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;
      border-right: 1px solid rgb(224, 224, 224);
      width: 430px;

      .item-container {
        overflow-y: auto;
        padding-right: 0;
        flex: 1;
      }
    }

    .result-container {
      padding: 20px;
      overflow-y: auto;
      overflow-x: hidden;
      flex: 1 1 auto;
      position: relative;
    }
  }
`;

const StyledEventsItemOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  .sub-container {
    width: 100%;
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

const buildItem = (id) => (
  <EventsItem key={id.toString()} id={id}>
    <StyledEventsItemOptionsContainer>
      <div className="sub-container">
        <EventsGroupByFieldOption id={id} />
        <EventsSplitByFieldOption id={id} />
        <AggregationContainer id={id} />
        <EventsAggregationFieldOption id={id} />
      </div>
      <div className="sub-container">
        <EventItemFilter id={id} />
        <EventPeriod id={id} />
      </div>
    </StyledEventsItemOptionsContainer>
  </EventsItem>
);

const EventsView = ({
  onExecute,
  executing,
  eventIds,
  onEventAdd,
  executeDisabled,
  extraActions,
  onRequestCancel,
  cancelButtonDisabled,
}) => (
  <>
    <NavigationBar
      onExecute={onExecute}
      executeDisabled={executeDisabled || executing}
      extraActions={extraActions}
    />
    <StyledEventsViewContainer>
      <SpinnerWithButton
        onClick={onRequestCancel}
        disabled={cancelButtonDisabled}
        executing={executing}
      >
        <div className="wrapper-sidelist-container">
          <div className="sidelist-container">
            <div className="item-container">{eventIds.map(buildItem)}</div>
            <div>
              <StyledButton onClick={onEventAdd} type="primary">
                Add event
              </StyledButton>
            </div>
          </div>
          <div className="result-container">
            <Result />
          </div>
          <EventsTemplatesDrawerMenu />
        </div>
      </SpinnerWithButton>
    </StyledEventsViewContainer>
  </>
);

export default EventsView;
